import { ArrowRight } from "lucide-react";
import { useSite } from "../context/SiteContent";
import { PageHero, ContactList, HoursTable, Eyebrow } from "./parts";
import { BookingButton } from "./Booking";

export default function ContactPage() {
  const { content } = useSite();
  const b = content.business || {};
  const embed = b.maps_embed_url;
  return (
    <>
      <PageHero eyebrow="Kontakt" title="So erreichen Sie uns" text={b.tagline} action={<BookingButton testid="contact-booking-button" />} />
      <div className="max-w-6xl mx-auto px-5 py-12 sm:py-16 grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-5 space-y-6">
          <div className="rounded-2xl bg-white border border-stone-200/70 p-7 shadow-sm" data-testid="contact-card">
            <Eyebrow>Kontakt</Eyebrow>
            <h2 className="font-serif text-3xl text-stone-900 mt-2 mb-5">{b.name}</h2>
            <ContactList b={b} />
            <div className="flex flex-wrap gap-3 mt-6 items-center">
              <BookingButton variant="dark" testid="contact-card-booking-button" />
              {b.maps_url && <a href={b.maps_url} target="_blank" rel="noreferrer" data-testid="contact-maps-link" className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--brand-primary)]">In Google Maps öffnen <ArrowRight className="h-4 w-4" /></a>}
            </div>
          </div>
          <div className="rounded-2xl bg-[#F1EAE0] p-7" data-testid="contact-hours">
            <Eyebrow>Öffnungszeiten</Eyebrow>
            <div className="mt-4"><HoursTable hours={content.hours} special={content.special_hours} /></div>
          </div>
        </div>
        <div className="lg:col-span-7">
          {embed ? (
            <iframe title="Standort" src={embed} className="w-full h-[420px] lg:h-full min-h-[420px] rounded-2xl border border-stone-200/70" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-testid="contact-map" />
          ) : (
            <div className="w-full h-[420px] rounded-2xl bg-white border border-dashed border-stone-300 flex items-center justify-center text-sm text-stone-500 text-center px-6" data-testid="contact-map-placeholder">
              Karte wird angezeigt, sobald eine Google-Maps-Einbettung in den Geschäftsinformationen hinterlegt ist.
            </div>
          )}
        </div>
      </div>
      {b.description && <div className="max-w-3xl mx-auto px-5 pb-10 text-stone-700 leading-relaxed whitespace-pre-line" data-testid="contact-description">{b.description}</div>}
    </>
  );
}
